/* Shared Buy More, Save More discount reconciliation and lazy UI loading. */
var bastionDiscountCodeKey = (code) => String(code || '').trim().toLowerCase();

var bastionVolumeDiscountConfig = window.bastionVolumeDiscountConfig || {};
var bastionVolumeDiscountCodes = Array.isArray(bastionVolumeDiscountConfig.tierCodes)
  ? bastionVolumeDiscountConfig.tierCodes.map((code) => String(code || '').trim())
  : [];
var bastionVolumeEligibleProductIdsPromise = null;
var bastionVolumeProductEligibility = new Map();

var bastionVolumePreferenceKey = 'bastion-volume-discount-removed-cart';
var bastionVolumeCurrentCartId = '';
var bastionVolumeRemovedCartId = '';
var bastionVolumeRemovalPending = false;
var bastionVolumePreferenceStorage = true;

var bastionResumeAutomaticVolumeDiscount = () => {
  bastionVolumeRemovedCartId = '';
  bastionVolumeRemovalPending = false;
  try { localStorage.removeItem(bastionVolumePreferenceKey); } catch { bastionVolumePreferenceStorage = false; }
};

var bastionPauseAutomaticVolumeDiscount = () => {
  bastionVolumeRemovedCartId = bastionVolumeCurrentCartId;
  bastionVolumeRemovalPending = !bastionVolumeCurrentCartId;
  if (bastionVolumeCurrentCartId) {
    try { localStorage.setItem(bastionVolumePreferenceKey, bastionVolumeCurrentCartId); } catch { bastionVolumePreferenceStorage = false; }
  }
};

var bastionVolumeDiscountWasRemoved = (cart) => {
  const cartId = String(cart?.token || '').split('?')[0];
  if (cartId) bastionVolumeCurrentCartId = cartId;
  if (!cart?.items?.length) {
    bastionResumeAutomaticVolumeDiscount();
    return false;
  }
  if (bastionVolumeRemovalPending && cartId) {
    bastionPauseAutomaticVolumeDiscount();
  }
  if (bastionVolumePreferenceStorage) {
    try { bastionVolumeRemovedCartId = localStorage.getItem(bastionVolumePreferenceKey) || ''; } catch { bastionVolumePreferenceStorage = false; }
  }
  return bastionVolumeRemovalPending || Boolean(cartId && bastionVolumeRemovedCartId === cartId);
};

window.bastionResumeAutomaticVolumeDiscount = bastionResumeAutomaticVolumeDiscount;

document.addEventListener('click', (event) => {
  const control = event.target.closest?.('cart-discount-remove-button[discount-code]');
  if (!control?.closest('#cart-drawer, .bastion-cart-page')) return;
  const code = bastionDiscountCodeKey(control.getAttribute('discount-code'));
  if (bastionVolumeDiscountCodes.some(tier => bastionDiscountCodeKey(tier) === code)) {
    bastionPauseAutomaticVolumeDiscount();
  }
}, true);

var bastionFetchEligibleVolumeProductIds = async () => {
  const handle = String(bastionVolumeDiscountConfig.eligibleCollectionHandle || '').trim();

  if (!handle) return null;

  if (!bastionVolumeEligibleProductIdsPromise) {
    const root = window.Shopify?.routes?.root || '/';
    const collectionUrl = `${root}collections/${encodeURIComponent(handle)}/products.json?limit=250`;

    bastionVolumeEligibleProductIdsPromise = fetch(collectionUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then(async (response) => {
      if (!response.ok) throw new Error('The eligible pen collection could not be loaded.');

      const responseJson = await response.json();
      return new Set((responseJson.products || []).map((product) => String(product.id)));
    }).catch((error) => {
      console.warn('[Buy More, Save More]', error);
      return null;
    });
  }

  return bastionVolumeEligibleProductIdsPromise;
};

var bastionVolumeItemHasOffer = async (item) => {
  const productId = String(item?.product_id || '');

  if (bastionVolumeProductEligibility.has(productId)) {
    return bastionVolumeProductEligibility.get(productId);
  }

  const eligibilityPromise = (async () => {
    if (!item?.url) return false;

    try {
      const url = new URL(item.url, window.location.origin);
      url.search = '';

      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) return false;

      const html = await response.text();
      return Boolean(new DOMParser().parseFromString(html, 'text/html').querySelector('bastion-volume-offer'));
    } catch (error) {
      return false;
    }
  })();

  bastionVolumeProductEligibility.set(productId, eligibilityPromise);
  return eligibilityPromise;
};

var bastionEligibleVolumeQuantity = async (cart) => {
  const items = Array.isArray(cart?.items) ? cart.items : [];

  if (items.length === 0) return 0;

  const eligibleProductIds = await bastionFetchEligibleVolumeProductIds();

  if (eligibleProductIds) {
    return items.reduce((quantity, item) => (
      eligibleProductIds.has(String(item.product_id))
        ? quantity + Math.max(0, Number.parseInt(item.quantity || '0', 10))
        : quantity
    ), 0);
  }

  const eligibility = await Promise.all(items.map((item) => bastionVolumeItemHasOffer(item)));

  return items.reduce((quantity, item, index) => (
    eligibility[index]
      ? quantity + Math.max(0, Number.parseInt(item.quantity || '0', 10))
      : quantity
  ), 0);
};

var bastionVolumeDiscountForQuantity = (quantity) => {
  const tiers = Array.isArray(bastionVolumeDiscountConfig.tiers) ? bastionVolumeDiscountConfig.tiers : [];

  for (let index = tiers.length - 1; index >= 0; index -= 1) {
    const tier = tiers[index];
    const minimum = Number.parseInt(tier?.minimum, 10);
    const maximum = Math.max(minimum, Number.parseInt(tier?.maximum, 10));

    if (tier?.enabled && quantity >= minimum && (tier.unlimited || quantity <= maximum)) {
      return bastionVolumeDiscountCodes[index] || '';
    }
  }

  return '';
};

var bastionReconcileVolumeDiscount = async (currentCart = null, sections = []) => {
  const root = window.Shopify?.routes?.root || '/';
  const cart = currentCart || await fetch(`${root}cart.js`).then((response) => response.json());
  bastionVolumeDiscountWasRemoved(cart);
  const eligibleQuantity = await bastionEligibleVolumeQuantity(cart);
  const desiredCode = bastionVolumeDiscountWasRemoved(cart) ? '' : bastionVolumeDiscountForQuantity(eligibleQuantity);
  const configuredCodes = new Set(bastionVolumeDiscountCodes.map(bastionDiscountCodeKey).filter(Boolean));
  const cartCodes = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
  const currentTierCodes = cartCodes.filter((discount) => configuredCodes.has(bastionDiscountCodeKey(discount.code)));
  const desiredCodeKey = bastionDiscountCodeKey(desiredCode);
  const alreadyCorrect = desiredCode
    ? currentTierCodes.length === 1 && bastionDiscountCodeKey(currentTierCodes[0].code) === desiredCodeKey
    : currentTierCodes.length === 0;

  if (alreadyCorrect) {
    return { cart, error: '', changed: false, eligibleQuantity, discountCode: desiredCode };
  }

  const nextCodes = cartCodes
    .filter((discount) => discount.applicable && !configuredCodes.has(bastionDiscountCodeKey(discount.code)))
    .map((discount) => discount.code);

  if (desiredCode) nextCodes.push(desiredCode);

  const response = await fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      discount: nextCodes.join(','),
      sections: sections.join(','),
    }),
  });
  const responseJson = await response.json();

  if (!response.ok) {
    return {
      cart,
      error: responseJson.description || responseJson.message || 'The Buy More, Save More discount could not be updated.',
      changed: false,
      eligibleQuantity,
      discountCode: desiredCode,
    };
  }

  let error = '';

  if (desiredCode && Array.isArray(responseJson.discount_codes)) {
    const selectedDiscount = responseJson.discount_codes.find(
      (discount) => bastionDiscountCodeKey(discount.code) === desiredCodeKey
    );

    if (!selectedDiscount?.applicable) {
      error = `The cart qualifies, but “${desiredCode}” could not be applied. Review the discount requirements in Shopify Admin.`;
    }
  }

  return {
    cart: responseJson,
    error,
    changed: true,
    eligibleQuantity,
    discountCode: desiredCode,
  };
};

window.bastionReconcileVolumeDiscount = bastionReconcileVolumeDiscount;

var bastionVolumeUiScriptPromises = new Map();

var bastionLoadVolumeUiScript = ({ definition, scriptUrl, dataAttribute, label }) => {
  if (customElements.get(definition)) return Promise.resolve();
  if (bastionVolumeUiScriptPromises.has(definition)) return bastionVolumeUiScriptPromises.get(definition);

  const normalizedScriptUrl = String(scriptUrl || '').trim();

  if (!normalizedScriptUrl) return Promise.resolve();

  const existingScript = document.querySelector(`script[${dataAttribute}]`);
  const script = existingScript || document.createElement('script');
  const scriptPromise = new Promise((resolve, reject) => {
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', () => reject(new Error(`${label} could not be loaded.`)), { once: true });
  });

  bastionVolumeUiScriptPromises.set(definition, scriptPromise);

  if (!existingScript) {
    script.src = normalizedScriptUrl;
    script.async = true;
    script.setAttribute(dataAttribute, '');
    document.head.append(script);
  }

  return scriptPromise;
};

var bastionLoadProductVolumeOfferUi = () => bastionLoadVolumeUiScript({
  definition: 'bastion-volume-offer',
  scriptUrl: bastionVolumeDiscountConfig.productUiScriptUrl,
  dataAttribute: 'data-bastion-volume-product-ui',
  label: 'The Buy More, Save More product interface',
});

var bastionLoadCartVolumeOfferUi = () => bastionLoadVolumeUiScript({
  definition: 'bastion-cart-volume-offer',
  scriptUrl: bastionVolumeDiscountConfig.cartUiScriptUrl,
  dataAttribute: 'data-bastion-volume-cart-ui',
  label: 'The Buy More, Save More cart interface',
});

var bastionLoadVolumeOfferUi = () => Promise.all([
  bastionLoadProductVolumeOfferUi(),
  bastionLoadCartVolumeOfferUi(),
]);

window.bastionLoadVolumeOfferUi = bastionLoadVolumeOfferUi;

var bastionWarnVolumeUiError = (error) => console.warn('[Buy More, Save More]', error);
var bastionRequestVolumeOfferUi = () => bastionLoadVolumeOfferUi().catch(bastionWarnVolumeUiError);
var bastionRequestCartVolumeOfferUi = () => bastionLoadCartVolumeOfferUi().catch(bastionWarnVolumeUiError);

var bastionVisibleVolumeOffers = (root, selector) => {
  const offers = root.matches?.(selector)
    ? [root]
    : Array.from(root.querySelectorAll?.(selector) || []);

  return offers.filter((offer) => !offer.hidden && offer.getClientRects().length > 0);
};

var bastionRequestVisibleVolumeOfferUi = (root = document) => {
  const requests = [];

  if (bastionVisibleVolumeOffers(root, 'bastion-volume-offer').length > 0) {
    requests.push(bastionLoadProductVolumeOfferUi());
  }

  if (bastionVisibleVolumeOffers(root, 'bastion-cart-volume-offer').length > 0) {
    requests.push(bastionLoadCartVolumeOfferUi());
  }

  Promise.all(requests).catch(bastionWarnVolumeUiError);
};

['pointerdown', 'click', 'focusin', 'keydown'].forEach((eventName) => {
  document.addEventListener(eventName, bastionRequestVolumeOfferUi, {
    capture: true,
    once: true,
    passive: eventName === 'pointerdown',
  });
});

document.addEventListener('shopify:section:load', (event) => {
  bastionRequestVisibleVolumeOfferUi(event.target);
});
document.addEventListener('theme:loading:end', () => {
  bastionRequestVisibleVolumeOfferUi();
});

var bastionVolumeDiscountAutoState = {
  cart: null,
  pending: false,
  running: false,
};

var bastionRunAutomaticVolumeDiscount = async () => {
  if (bastionVolumeDiscountAutoState.running) return;

  bastionVolumeDiscountAutoState.running = true;

  try {
    while (bastionVolumeDiscountAutoState.pending) {
      bastionVolumeDiscountAutoState.pending = false;
      const cart = bastionVolumeDiscountAutoState.cart;
      bastionVolumeDiscountAutoState.cart = null;
      const sectionsToBundle = new Set();

      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }));

      const result = await bastionReconcileVolumeDiscount(cart, Array.from(sectionsToBundle));

      if (!result.changed) continue;

      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
        return;
      }

      if (result.cart?.sections && Object.keys(result.cart.sections).length > 0) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'bastion:volume-discount', cart: result.cart },
        }));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      if (result.error) console.warn('[Buy More, Save More]', result.error);
    }
  } catch (error) {
    console.warn('[Buy More, Save More]', error);
  } finally {
    bastionVolumeDiscountAutoState.running = false;

    if (bastionVolumeDiscountAutoState.pending) {
      queueMicrotask(bastionRunAutomaticVolumeDiscount);
    }
  }
};

var bastionScheduleAutomaticVolumeDiscount = (cart = null) => {
  bastionVolumeDiscountAutoState.cart = cart;
  bastionVolumeDiscountAutoState.pending = true;
  queueMicrotask(bastionRunAutomaticVolumeDiscount);
};

document.addEventListener('cart:change', (event) => {
  bastionScheduleAutomaticVolumeDiscount(event.detail?.cart || null);
  bastionRequestCartVolumeOfferUi();
});
document.addEventListener('cart:refresh', () => {
  bastionScheduleAutomaticVolumeDiscount();
  bastionRequestCartVolumeOfferUi();
});
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    bastionScheduleAutomaticVolumeDiscount();
    bastionRequestVisibleVolumeOfferUi();
  }
});

var bastionInitializeVolumeDiscount = () => {
  const initialCartItemCount = Number.parseInt(bastionVolumeDiscountConfig.initialCartItemCount || '0', 10);

  if (initialCartItemCount > 0) bastionScheduleAutomaticVolumeDiscount();
  else bastionResumeAutomaticVolumeDiscount();
  bastionRequestVisibleVolumeOfferUi();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bastionInitializeVolumeDiscount, { once: true });
} else {
  bastionInitializeVolumeDiscount();
}

var bastionApplyTierDiscount = async (_offer, _discountCode, sections = [], currentCart = null) => {
  bastionResumeAutomaticVolumeDiscount();
  return bastionReconcileVolumeDiscount(currentCart, sections);
};
